// theme-utils.ts
// Tiny helpers for resolving theme state from AntD tokens.

/** Returns true if the given hex/rgb(a) color reads as "dark" by relative
 *  luminance (used to flip light-mode-only visuals like the wordmark SVG
 *  which is monochrome white). Accepts `#RRGGBB`, `#RGB`, `rgb(...)`, or
 *  `rgba(...)`; returns false for anything it can't parse. */
export function isDarkBg(color: string | undefined): boolean {
  if (!color) return false;
  let r: number, g: number, b: number;
  const hex = /^#([a-f\d]{3}|[a-f\d]{6})$/i.exec(color);
  if (hex) {
    const v = hex[1];
    const long = v.length === 6 ? v : v.split('').map((c) => c + c).join('');
    r = parseInt(long.slice(0, 2), 16);
    g = parseInt(long.slice(2, 4), 16);
    b = parseInt(long.slice(4, 6), 16);
  } else {
    const rgb = /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i.exec(color);
    if (!rgb) return false;
    r = parseInt(rgb[1], 10);
    g = parseInt(rgb[2], 10);
    b = parseInt(rgb[3], 10);
  }
  // Standard relative-luminance approximation.
  return (0.299 * r + 0.587 * g + 0.114 * b) < 128;
}
